
<div class="donutChart" :style="{ backgroundImage: this.calculatedBackgroundImage }">
  <div class="donutChart__rating" :class="{ 'no_data' : rating === 0 }">{{ rating > 0 ? rating.toFixed(1) : 'データなし' }}</div>
</div>
